<template>
  <el-row class="p30 white">
    <el-col :span="24" class="account-info">
      <img src="~@/images/common/common_avater.jpg" alt="">
      <div class="welcome ml20">
        <div>xxx ，欢迎进入船票票务系统！</div>
        <div>上次登录：2019年7月10日 星期三 20:30:23</div>
      </div>
    </el-col>
  </el-row>

  <el-row class="p30 white mt20">
    <el-col :span="24" class="account-list">
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-setting"></i>
        <div>企业设置</div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-platform-eleme"></i>
        <div>组织架构</div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-s-check"></i>
        <div>职务权限</div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-s-custom"></i>
        <div>账号管理</div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-s-grid"></i>
        <div>模块管理</div>
      </el-card>
    </el-col>
    <el-col :span="24" class="account-list mt20">
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-box"></i>
        <div>船票管理</div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-edit-outline"></i>
        <div>计费设置</div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-c-scale-to-original"></i>
        <div>订单列表</div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-collection"></i>
        <div>字典管理</div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-date"></i>
        <div>日志管理</div>
      </el-card>
    </el-col>
  </el-row>

  <el-row class="p30 white mt20">
    <el-col :span="24" class="account-history-head">
      <i class="el-icon-message-solid"></i>
      <div class="ml10">历史登陆日志</div>
    </el-col>
    <el-col :span="24" class="account-history-list">
      <el-divider></el-divider>

      <div>
        <div class="history-info">
          <div class="login-city">
            <span class="mr25">登陆成功</span>
            <strong>登陆IP  10.161.5.203</strong>
          </div>
          <div class="login-user">
            <el-avatar icon="el-icon-user-solid"></el-avatar>
            <div class="login-user-name ml10">李小明</div>
            <i class="el-icon-timer ml10"></i>
            <div class="login-user-time ml10">2019-04-10 09:00</div>
          </div>
        </div>
        <el-divider></el-divider>
      </div>
      <div>
        <div class="history-info">
          <div class="login-city">
            <span class="mr25">登陆成功</span>
            <strong>登陆IP  10.161.5.203</strong>
          </div>
          <div class="login-user">
            <el-avatar icon="el-icon-user-solid"></el-avatar>
            <div class="login-user-name ml10">李小明</div>
            <i class="el-icon-timer ml10"></i>
            <div class="login-user-time ml10">2019-04-10 09:00</div>
          </div>
        </div>
        <el-divider></el-divider>
      </div>
      <div>
        <div class="history-info">
          <div class="login-city">
            <span class="mr25">登陆成功</span>
            <strong>登陆IP  10.161.5.203</strong>
          </div>
          <div class="login-user">
            <el-avatar icon="el-icon-user-solid"></el-avatar>
            <div class="login-user-name ml10">李小明</div>
            <i class="el-icon-timer ml10"></i>
            <div class="login-user-time ml10">2019-04-10 09:00</div>
          </div>
        </div>
        <el-divider></el-divider>
      </div>
      <div>
        <div class="history-info">
          <div class="login-city">
            <span class="mr25">登陆成功</span>
            <strong>登陆IP  10.161.5.203</strong>
          </div>
          <div class="login-user">
            <el-avatar icon="el-icon-user-solid"></el-avatar>
            <div class="login-user-name ml10">李小明</div>
            <i class="el-icon-timer ml10"></i>
            <div class="login-user-time ml10">2019-04-10 09:00</div>
          </div>
        </div>
        <el-divider></el-divider>
      </div>

    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "managementHome",
  setup() {
    
    return {

    };
  },
};
</script>

<style scoped lang='less'>
.account-info{
  display: flex;
  align-items: center;
  img{
    width: 120px;
    border-radius: 50%;
  }
  .welcome{
    line-height: 50px;
    color: #999;
  }
}
:deep(.el-card__body){
  padding: 20px 50px;
}
.account-list{
  display: flex;
  justify-content: space-between;
  .box-card{
    cursor: pointer;
    i{
      font-size: 100px;
      color: #66b1ff;
    }
    div{
      font-size: 18px;
      text-align: center;
      margin-top: 10px;
    }
  }
}
.account-history-head{
  display: flex;
  align-items: center;
  i{
    font-size: 28px;
    color: #66b1ff;
  }
}
.account-history-list{
  .history-info{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .login-user{
      display: flex;
      align-items: center;
    }
  }
}
</style>
